const ChevronRight = (props) => {
  return (
    <svg
      viewBox="0 0 24 24"
      fill='currentColor'
      aria-hidden="true"
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
      />
    </svg>
  )
}

export default ChevronRight
